import { useParams } from 'react-router-dom';
import { ModelViewer } from './ModelViewer';
import { useState, useEffect } from 'react';
import { resourceApi } from '../NejlikaApi';
import Cookies from 'js-cookie';

interface ModelEmbeddedProps {
}

export const ModelEmbedded: React.FC<ModelEmbeddedProps> = ({ }) => {
    const  { "*": modelPath } = useParams();
    const [modelUrl, setModelUrl] = useState<string | null>(null);

    const project = Cookies.get('project') || "default";

    useEffect(() => {
        if (modelPath) {
            resourceApi.getGeometryUrl(project, modelPath).then(setModelUrl);
        }
    }, [modelPath, project]);

    if (!modelPath || !modelUrl) {
        return null;
    }
    
    return (
        <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
            <ModelViewer modelUrl={modelUrl} />
        </div>
    );
}